import type { Middleware } from '@reduxjs/toolkit'
import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

import { logger } from '@/utils/logger'

import { apiSlice } from './api/apiSlice'

const dataLoadingLogger: Middleware = store => next => action => {
  if (
    import.meta.env.DEV &&
    typeof (action as { type?: string }).type === 'string' &&
    (action as { type: string }).type === 'api/executeQuery/pending'
  ) {
    const a = action as {
      meta?: {
        arg?: {
          endpointName?: string
          originalArgs?: unknown
          queryCacheKey?: string
        }
      }
    }
    const endpointName = a.meta?.arg?.endpointName ?? 'unknown'
    const args = a.meta?.arg?.originalArgs
    const cacheKey = a.meta?.arg?.queryCacheKey
    const state = store.getState() as {
      api?: { queries?: Record<string, { status?: string }> }
    }
    const cached = cacheKey ? state.api?.queries?.[cacheKey] : undefined

    if (cached?.status === 'fulfilled') {
      logger.log(
        `[memory] ${endpointName}(${JSON.stringify(args)}) — cache hit`,
      )
    } else {
      logger.log(
        `[server] ${endpointName}(${JSON.stringify(args)}) — fetching…`,
      )
    }
  }
  return next(action)
}

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(apiSlice.middleware, dataLoadingLogger),
})

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
